import { provideOAuthClient } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';

export const oauthProviders = [
  provideOAuthClient({
    resourceServer: {
      allowedUrls: [
        'https://auth.praceprofirmy.cz/admin/v1',
        'https://auth.praceprofirmy.cz/management/v1',
        'https://auth.praceprofirmy.cz/auth/v1/',
        'https://auth.praceprofirmy.cz/v2/',
        environment.graphqlUrl,
        environment.apiUrl,
      ],
      sendAccessToken: true,
    },
  }),
];
